/**
 * Stable CSS class names for E2E / automation — Cookie Management.
 */
export const CKM = {
    page: 'cookie-management-page',
    titleArea: 'cookie-management-page__title',
    toolbar: 'cookie-management-page__toolbar',
    datagrid: 'cookie-management-page__datagrid',

    input: 'cookie-management-input',
    inputButton: 'cookie-management-input--button',
    inputSwitch: 'cookie-management-input--switch',
    inputIconButton: 'cookie-management-input--icon-button',
    inputMenuItem: 'cookie-management-input--menu-item',
    inputSelect: 'cookie-management-input--select',
    inputTextfield: 'cookie-management-input--textfield',

    btnAddCookie: 'cookie-management-field--add-cookie',

    gridSwitchAndroid: 'cookie-management-field--grid-android',
    gridSwitchIos: 'cookie-management-field--grid-ios',
    gridSwitchStatus: 'cookie-management-field--grid-status',

    rowActionsTrigger: 'cookie-management-field--row-actions-trigger',
    rowActionEdit: 'cookie-management-field--row-action-edit',
    rowActionDelete: 'cookie-management-field--row-action-delete',

    drawer: 'cookie-management-drawer',
    drawerHeader: 'cookie-management-drawer__header',
    drawerClose: 'cookie-management-drawer__close',
    drawerBody: 'cookie-management-drawer__body',
    drawerPlatforms: 'cookie-management-drawer__platforms',
    drawerActions: 'cookie-management-drawer__actions',

    fieldCookieType: 'cookie-management-field--cookie-type',
    fieldCookieName: 'cookie-management-field--cookie-name',
    fieldUsageTime: 'cookie-management-field--usage-time',
    fieldUsagePurpose: 'cookie-management-field--usage-purpose',
    fieldSiteName: 'cookie-management-field--site-name',
    fieldStatusSelect: 'cookie-management-field--status-select',
    fieldIosSwitch: 'cookie-management-field--ios-switch',
    fieldAndroidSwitch: 'cookie-management-field--android-switch',

    btnDrawerSave: 'cookie-management-field--drawer-save',
    btnDrawerUpdate: 'cookie-management-field--drawer-update',
} as const;

export const ckmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
